import { render } from "./SongCardButton.vue?vue&type=template&id=692194a2"
import script from "./SongCardButton.vue?vue&type=script&lang=js"
export * from "./SongCardButton.vue?vue&type=script&lang=js"
script.render = render

export default script